// extracted by mini-css-extract-plugin
export var bodyContainer = "iwoNw";
export var header = "NVfHT";
export var headerTitle = "h72u9";
export var iframeContainer = "zbRx3";
export var loadingCover = "Mu7nT";
export var logo = "VR4Tg";
export var titleText = "cgXjW";